import React, { useState } from "react";

import { View, StyleSheet } from "react-native";
import { Text } from "@/app/components/Text";
import { TouchableOpacity } from "../../Buttons";
import { colors, fontSizes } from "@/app/constants/styles";
import { useTranslateText } from "@/app/utils";
import OrderConfirmModal from "./OrderConfirmModal";

type PlaceOrderProps = {
  onPlaceOrderPress: () => void;
  disabled: boolean;
  basketTotal: string;
  buttonText: string;
};

const PlaceOrder = ({
  onPlaceOrderPress,
  disabled,
  basketTotal,
  buttonText,
}: PlaceOrderProps): JSX.Element => {
  const { t } = useTranslateText();
  const [isModalVisible, setModalVisible] = useState(false);

  const handlePlaceOrderPress = () => {
    setModalVisible(true);
    onPlaceOrderPress(); // Call the original handler if needed
  };

  return (
    <>
      <TouchableOpacity
        testID="placeOrderButton"
        style={styles.container}
        onPress={handlePlaceOrderPress}
        disabled={disabled}
      >
        <View style={[styles.button, disabled && styles.disabledButton]}>
          <Text style={styles.buttonText}>{t(buttonText)}</Text>
          <View style={styles.totalContainer}>
            <Text style={styles.totalText}>{t("orderScreen.total")}</Text>
            <Text
              accessible
              accessibilityRole="text"
              accessibilityLabel="Order total"
              style={styles.buttonText}
            >
              {basketTotal}
            </Text>
          </View>
        </View>
      </TouchableOpacity>
      <OrderConfirmModal
        visible={isModalVisible}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
};

export const styles = StyleSheet.create({
  container: {
    paddingBottom: 5,
  },
  button: {
    backgroundColor: colors.albaikRed,
    alignItems: "center",
    height: 50,
    borderRadius: 8,
    justifyContent: "space-between",
    paddingHorizontal: 10,
    flexDirection: "row",
  },
  noTotal: {
    justifyContent: "center",
  },
  disabledButton: {
    opacity: 0.5,
  },
  totalContainer: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
  totalText: {
    fontSize: fontSizes.x8,
    color: colors.white,
  },
  buttonText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
});

export default PlaceOrder;
